import { RootState } from '../store';
import { settingsSlice } from './settings-slice';
import { ISettingsState } from './settings-interface';

export const {
  setUserAccount,
  setBootstrapApp,
  setPermissions,
  setBusinessArea,
  setService,
  setCurrentFile,
  setDisclaimerModal,
  setIsLoading,
  setHash,
  setCurrentSummary,
  setSummaryEdited,
  setFeedbackConfirmation,
  setRegenerateExtraction,
  setGeneratingExtraction,
  setEmailChain,
  setBetaWelcomeModal,
  setCurrentSupportPath,
  setSelectedHighlight,
  setHighlightCoords,
  setShowHighlights,
  setIsSelectLanguageModal,
  setSelectedLanguage,
  setInputSize,
  setIsEstimatedCostModal,
  setCoverageCheckV2Id,
  setCoverageCheckV2Files,
  setUserRoles,
  setUserBusinessUnits,
  setSelectedBusinessUnit,
  setSelectedDocuments,
  setCanSelectDocuments
} = settingsSlice.actions;

export const getUserName = (state: RootState): string | undefined =>
  state.settings.userAccount.name;

export const getUserEmail = (state: RootState): string | undefined =>
  state.settings.userAccount.username;

export const getBootstrapApp = (
  state: RootState
): ISettingsState['bootstrap'] => state.settings.bootstrap;

export const getPermission = (
  state: RootState
): ISettingsState['permissions'] => state.settings.permissions;

export const getBusinessArea = (
  state: RootState
): ISettingsState['businessArea'] => state.settings.businessArea;

export const getService = (state: RootState): ISettingsState['service'] =>
  state.settings.service;

export const getCurrentFile = (
  state: RootState
): ISettingsState['currentFile'] => state.settings.currentFile;

export const getDisclaimerModal = (
  state: RootState
): ISettingsState['isDisclaimerModal'] => state.settings.isDisclaimerModal;

export const getIsLoading = (state: RootState): ISettingsState['isLoading'] =>
  state.settings.isLoading;

export const getHash = (state: RootState): ISettingsState['hash'] =>
  state.settings.hash;

export const getCurrentSummary = (
  state: RootState
): ISettingsState['currentSummary'] => state.settings.currentSummary;

export const getSummaryEdited = (
  state: RootState
): ISettingsState['summaryEdited'] => state.settings.summaryEdited;

export const getFeedbackConfirmation = (
  state: RootState
): ISettingsState['isFeedbackConfirmation'] =>
  state.settings.isFeedbackConfirmation;

export const getRegenerateExtraction = (
  state: RootState
): ISettingsState['regenerateExtraction'] =>
  state.settings.regenerateExtraction;

export const getGeneratingExtraction = (
  state: RootState
): ISettingsState['isGeneratingExtraction'] =>
  state.settings.isGeneratingExtraction;

export const getEmailChain = (state: RootState): ISettingsState['emailChain'] =>
  state.settings.emailChain;

export const getBetaWelcomeModal = (
  state: RootState
): ISettingsState['isBetaWelcomeModal'] => state.settings.isBetaWelcomeModal;

export const getCurrentSupportPath = (
  state: RootState
): ISettingsState['currentSupportPath'] => state.settings.currentSupportPath;

export const getHomeAccountId = (state: RootState): string =>
  state.settings.userAccount.homeAccountId;

export const getSelectedHighlight = (state: RootState): number | undefined =>
  state.settings.selectedHighlight;

export const getHighlightCoords = (state: RootState): number | undefined =>
  state.settings.highlightCoords;

export const getShowHighlights = (state: RootState): boolean =>
  state.settings.showHighlights;

export const getIsSelectLanguageModal = (state: RootState): boolean =>
  state.settings.isSelectLanguageModal;

export const getSelectedLanguage = (state: RootState): string =>
  state.settings.selectedLanguage;

export const getInputSize = (state: RootState): number | undefined =>
  state.settings.inputSize;

export const getIsEstimatedCostModal = (state: RootState): boolean =>
  state.settings.isEstimatedCostModal;

export const getCoverageCheckV2Id = (state: RootState): string | undefined =>
  state.settings.coverageCheckV2Id;

export const getCoverageCheckV2Files = (
  state: RootState
): ISettingsState['coverageCheckV2Files'] =>
  state.settings.coverageCheckV2Files;

export const getUserRoles = (state: RootState): ISettingsState['userRoles'] =>
  state.settings.userRoles;

export const getUserBusinessUnits = (
  state: RootState
): ISettingsState['userBusinessUnits'] => state.settings.userBusinessUnits;

export const getSelectedBusinessUnit = (
  state: RootState
): ISettingsState['selectedBusinessUnit'] =>
  state.settings.selectedBusinessUnit;

export const getSelectedDocuments = (state: RootState): string[] =>
  state.settings.selectedDocuments;

export const getCanSelectDocuments = (state: RootState): boolean =>
  state.settings.canSelectDocuments;
